// extracted by mini-css-extract-plugin
module.exports = {"expertiseWrapper":"style-module--expertise-wrapper--39Jf5","item":"style-module--item--1VxQJ","excerpt":"style-module--excerpt--1CesW"};